import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="text-center">
        <div className="text-white text-2xl font-semibold">Page not found</div>
        <div className="text-white/60 mt-2">This route doesn’t exist.</div>
        <Link
          to="/admin"
          className="inline-block mt-6 rounded-2xl px-5 py-3 bg-white/10 border border-white/10 text-white hover:bg-white/15 transition"
        >
          Back to Admin
        </Link>
      </div>
    </div>
  );
}
